import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { PasswordInput } from "../components/PasswordInput";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Register() {
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const { signup } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await signup(f.email, f.password, f.name); toast.success("Account created"); nav("/dashboard"); }
    catch (err) { toast.error(err.response?.data?.detail || "Could not sign up"); }
    finally { setLoading(false); }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="register-page" className="max-w-md mx-auto px-6 py-20">
      <div className="uppercase text-xs tracking-[0.3em] font-bold text-center" style={{color: "var(--secondary)"}}>Create account</div>
      <h1 className="font-serif text-5xl mt-3 text-center leading-none" style={{color: "var(--primary)"}}>Start creating.</h1>
      <form onSubmit={submit} className="mt-10 bg-white rounded-lg border hairline p-8 space-y-5">
        <div><Label>Name</Label><Input data-testid="register-name" required value={f.name} onChange={(e) => setF({...f, name: e.target.value})}/></div>
        <div><Label>Email</Label><Input data-testid="register-email" type="email" required value={f.email} onChange={(e) => setF({...f, email: e.target.value})}/></div>
        <div><Label>Password</Label><PasswordInput data-testid="register-password" required minLength={6} value={f.password} onChange={(e) => setF({...f, password: e.target.value})}/></div>
        <Button data-testid="register-submit" disabled={loading} type="submit" className="w-full btn-primary rounded-full py-6">{loading ? "Creating…" : "Create account"}</Button>
        <div className="relative py-2"><div className="metal-line absolute inset-x-0 top-1/2"/><div className="relative bg-white text-xs text-center text-[color:var(--text-muted)] w-fit mx-auto px-3">or</div></div>
        <Button data-testid="register-google" type="button" onClick={google} variant="outline" className="w-full rounded-full py-6">Continue with Google</Button>
      </form>
      <p className="mt-6 text-center text-sm text-[color:var(--text-muted)]">Already registered? <Link to="/login" className="underline">Sign in</Link></p>
    </div>
  );
}
